import { Component, Input, HostListener, OnInit, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger, AnimationEvent } from '@angular/animations';

import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { PopinModalRef } from '../popin-modal/popin-modal.ref';

@Component({
    selector: 'aa-popin-v2',
    templateUrl: './popin-v2.component.html',
    styleUrls: [
        './popin-v2.component.scss'
    ],
    animations: [
        trigger('showHide', [
            state('show', style({
                transform: 'translateX(-100%)'
            })),
            state('hide', style({
                transform: 'translateX(100%)'
            })),
            transition('show => hide', [
                animate('1s cubic-bezier(0.35, 0, 0.25, 1)')
            ]),
            transition('hide => show', [
                animate('1s cubic-bezier(0.35, 0, 0.25, 1)')
            ])
        ])
    ],
    standalone: false
})
export class PopinV2Component implements OnInit, OnDestroy
{
    @Input() width: number;
    @Input() isShown: boolean = false;
    @Input() onClose: () => void;
    private destroyator = new Subject();

    constructor (private popinModalRef: PopinModalRef)
    { }

    ngOnInit (): void
    {
        this.popinModalRef.overlayRef
            .backdropClick()
            .pipe(
                tap(() =>
                    this.closePopin()
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    @HostListener('window:keydown', ['$event'])
    handleKeyDown (event: KeyboardEvent)
    {
        if (event.key === 'Escape' && this.isShown)
        {
            this.closePopin();
        }
    }

    public onShowHide (event: AnimationEvent)
    {
        const { phaseName, fromState, toState } = event;

        if (fromState === 'show' && toState === 'hide' && phaseName === 'done')
        {
            this.popinModalRef.destroy(true);
        }
    }

    public calcRight ()
    {
        return (-1 * this.width);
    }

    public closePopin (): void
    {
        this.onClose();
    }
}
